module.exports = __webpack_public_path__ + "static/10_KPMG-d397f6a733239589254c92bb10440238.png";